// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"188":"4d32200a","889":"cd3ccaf9"}[chunkId] + ".chunk.js";
};